import { useState, useEffect } from 'react'

const Hero = () => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section className="relative min-h-screen flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/spoke-static/images/SPOKE_firefighter_light_doorway.jpg"
          alt="SPOKE film dramatic light beam streaming through firehouse doorway into dark smoky room"
          className={`hidden lg:block w-full h-full object-cover object-center transition-transform duration-[2000ms] ease-out contrast-[1.1] saturate-[1.05] brightness-[0.95] ${loaded ? 'scale-100' : 'scale-110'}`}
        />
        <img
          src="/spoke-static/images/SPOKE_hero_mobile.jpg"
          alt="SPOKE film firefighter Lieutenant E313 in full gear holding hose in dark training room"
          className={`block lg:hidden w-full h-full object-cover object-top transition-transform duration-[2000ms] ease-out contrast-[1.1] saturate-[1.05] brightness-[0.95] ${loaded ? 'scale-100' : 'scale-110'}`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1a] via-[#0a0f1a]/35 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0f1a]/25 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-12 pb-20 md:pb-28">
        <div className={`transition-all duration-1000 delay-300 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="mb-6">
            <img
              src="/spoke-static/images/spoke-logo.png"
              alt="SPOKE"
              className="h-[clamp(4rem,12vw,10rem)] w-auto drop-shadow-[0_4px_30px_rgba(0,0,0,0.8)]"
            />
          </h1>
        </div>

        <div className={`transition-all duration-1000 delay-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-[clamp(1.5rem,4vw,3.2rem)] font-bold leading-[1.15] text-white max-w-3xl font-poppins mb-6">
            When the bravest people you know are the ones in trouble.
          </h2>
        </div>

        <div className={`transition-all duration-1000 delay-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-[clamp(0.95rem,1.8vw,1.35rem)] text-gray-300 max-w-2xl leading-relaxed font-poppins font-light">
            A descent into maydays no one is talking about.<span className="hidden lg:inline"><br /></span><span className="inline lg:hidden"> </span>And the fight to change what happens next.
          </p>
        </div>

        <div className={`mt-10 flex items-center gap-1 transition-all duration-1000 delay-[1300ms] ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="w-8 h-[2px] bg-red-600"></div>
          <div className="w-5 h-[2px] bg-yellow-400"></div>
        </div>
      </div>

      <div className={`absolute bottom-6 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-[1600ms] ${loaded ? 'opacity-60' : 'opacity-0'}`}>
        <div className="w-5 h-8 border border-yellow-400/40 rounded-full flex justify-center">
          <div className="w-0.5 h-2 bg-yellow-400/60 rounded-full mt-1.5 animate-pulse"></div>
        </div>
      </div>
    </section>
  )
}

export default Hero